import React from 'react';
import './App.css';
import LoginComponent from './components/LoginComponent';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>MT Cidadão - Login Test</h1>
        <LoginComponent />
      </header>
    </div>
  );
}

export default App;
